import { GoBuildError } from '../errors/GoBuild.error';

export const checkThat = <F extends (...args: any[]) => boolean>( // eslint-disable-line
  rule: F,
  message: string,
  ...args: Parameters<F>
): void => {
  if (!rule(...args)) throw new GoBuildError(message);
};
